<template>
    <div class="w-100px gap-10px p-10px popup ">
        <div class="flex items-center  cursor-pointer bg-#fff w-100% mb-8px" @click="handleCopy">
            <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                <img src="@/assets/images/message/fuzhi.svg" alt="" class="w-full h-full">
            </div>
            <div class="text">
                {{ t('chatSelect.copy') }}
            </div>
        </div>
        <div class="flex  items-center cursor-pointer bg-#fff w-100% mb-8px" @click="handleReport"
            v-if="info?.type === 'ai'">
            <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                <img src="@/assets/images/message/jubao.svg" alt="" class="w-full h-full">

            </div>
            <div class="text">
                {{ t('chatSelect.report') }}
            </div>
        </div>
        <div v-if="!isShowFreeSelect">
            <div class="flex  items-center cursor-pointer bg-#fff w-100% mb-8px" @click="handleCreate"
                v-if="info?.type === 'ai' && !isFrist && !isImages">
                <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                    <img src="@/assets/images/message/shengtu.svg" alt="" class="w-full h-full">
                </div>
                <div class="text">
                    {{ t('chatSelect.create') }}
                </div>
            </div>
        </div>
        <div v-if="!isShowFreeSelect">
            <div class="flex  items-center cursor-pointer bg-#fff w-100% mb-8px" @click="handleCreateVideo"
                v-if="info?.type === 'ai' && !isFrist && !isVideo">
                <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                    <img src="@/assets/images/chat/chatRecord/video (1).svg" alt="" class="w-full h-full">
                </div>
                <div class="text">
                    {{ t('chatSelect.video') }}
                </div>
            </div>
        </div>
        <div class="flex  items-center cursor-pointer bg-#fff w-100% mb-8px" @click="handleTranslate"
            v-if="info?.type === 'ai'">
            <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                <img src="@/assets/images/message/fanyi_icon.svg" alt="" class="w-full h-full">

            </div>
            <div class="text">
                {{ t('chatSelect.translate') }}
            </div>
        </div>
        <div class="flex  items-center cursor-pointer bg-#fff w-100%" @click="handleDelete" v-if="index !== 0">
            <div class="w-24px h-24px flex item-centers justify-center mr-4px">
                <img src="@/assets/images/message/shanchu_icon.svg" alt="" class="w-full h-full">
            </div>
            <div class="text">
                {{ t('chatSelect.delete') }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { logEventSafe } from '@/plugins/firebase';
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps<{
    info: any
    messageLength: number
    index: number
    isShowFreeSelect: boolean
    isFrist: boolean
    isImages: any
    isVideo: any
}>()

const emit = defineEmits<{
    copy: [message: any]
    delete: [message: any]
    report: [message: any]
    create: [message: any]
    translate: [message: any]
    createVideo: [message: any]
}>()

const handleCopy = () => {

    emit('copy', props.info)
}


const handleReport = () => {
    emit('report', props.info)
}

const handleCreate = () => {
    // 历史回复创建图片埋点
    logEventSafe('history_reply_create_img_click')
    emit('create', props.info)
}

const handleCreateVideo = () => {
    emit('createVideo', props.info)
}

const handleTranslate = () => {
    emit('translate', props.info)
}

const handleDelete = () => {
    emit('delete', props.info)
}
</script>
<style scoped lang="scss">
.popup {
    border-radius: 10px;
    gap: 10px;
    background: #fff;
    // display: inline-block;
    flex: 0 0 auto;
    /* 不自动拉伸 */
}

.text {
    color: rgba(1, 3, 27, 0.5);
    font-weight: 500;
    font-size: 10px;
}
</style>